import React from 'react';
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Typography,
  Button,
  Link,
  Avatar,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: 'Features', href: 'features', type: 'scroll' },
    { label: 'Use Cases', href: 'use-cases', type: 'scroll' },
    { label: 'Pricing', href: 'pricing', type: 'scroll' },
    // { label: 'Insights', href: 'insights', type: 'scroll' },
    { label: 'About', href: '/home/about', type: 'route' },
  ];

  const handleScrollNavigation = (sectionId) => {
 
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      return;
    }

 
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleRoute = (path) => {
    navigate(path);
  };

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        bgcolor: 'white',
        color: 'text.primary',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            justifyContent: 'space-between',
          }}
        >
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: '#10b981',
                borderRadius: 1.5,
              }}
            >
              <Typography fontWeight="bold" fontSize="1.125rem" sx={{ color: '#fff' }}>
                {'{a}'}
              </Typography>
            </Avatar>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: '1.25rem',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/')}
            >
              getlista
            </Typography>
          </Box>

          {/* Navigation */}
          <Box
            sx={{
              display: { xs: 'none', lg: 'flex' },
              gap: 4,
              alignItems: 'center',
            }}
          >
            {navItems.map((item) => (
              <Link
                key={item.label}
                underline="none"
                onClick={() =>
                  item.type === 'scroll'
                    ? handleScrollNavigation(item.href)
                    : handleRoute(item.href)
                }
                sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                  },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Box>

          {/* Sign In */}
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
            <Button
              onClick={() => navigate('/login')}
              sx={{
                color: 'text.secondary',
                fontWeight: 500,
                '&:hover': {
                  bgcolor: 'transparent',
                  color: 'primary.main',
                },
              }}
            >
              Sign In
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;